// Description: This is the Error page, it will be displayed when the user tries to access a page that does not exist.
// Updated: 14/07/2025

// Material UI Components
import Button from '@mui/material/Button';

// Components and Functions for the project
import NotFound from '../../assets/ilustrations/notfound.svg';

// Styles for the component
import './Erro.css';

// Render The Component
function Erro() {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
            <img src={NotFound} style={{ width: '100%', height: 'auto', maxWidth: '600px' }} />
            <Button href='/painel' variant="contained" sx={{ borderRadius: '6px' }}>
                Voltar ao Painel
            </Button>
        </div>
    );
}

export default Erro;
